const addons = [
  {
    id: "bullseye_ai_trade_ideas",
    name: "Bullseye AI Trade Ideas",
    price: 99,
    description:
      "Get the Bullseye Trade Ideas that are generated from Longbow’s proprietary A.I. algorithms running on 2,000+ stock tickers throughout the trading day in order to identify highly probable, tactical Buy / Sell opportunities that can be monetized within 1-5 trading days.",
    selected: false,
  },
  {
    id: "sector_dashboard",
    name: "US Sector ETF Daily Dashboard",
    price: 20,
    description:
      "Get the Longbow data dashboard and signals for 20 US Sector Style ETFs, including XLY, XLF, XLV, XLK, XLP, XLI, XLB, XLE, XLU, XLRE, XLC, IBB, ITA, ITB, IAK, IHI, KBE, KRE, JETS, SMH.",
    selected: false,
  },
  {
    id: "equity_dashboard",
    name: "Global Equity ETF Daily Dashboard",
    price: 25,
    description:
      "Get the Longbow data dashboard and signals for 30 Global Equity ETFs, including CHIQ, GREK, NORW, PGAL, EWA, EWZ, EWC, EFA, EEM, EFNL, EDW, EWG, INDA, EIS, EWJ, EWW, ENZL, EPHE, ERUS, DSA, EWS, EZA, EWY, EQP, EWT, THD, KBA, KWEB, IDX, RSX.",
    selected: false,
  },
  {
    id: "currency_dashboard",
    name: "Global Currency ETF Daily Dashboard",
    price: 10,
    description:
      "Get the Longbow data dashboard and signals for 10 Global Currency ETFs, including UUP, FXE, FXF, FXC, FXY, FXA, FXB.",
    selected: false,
  },
  {
    id: "commodity_dashboard",
    name: "Global Commodity ETF Dashboard",
    price: 20,
    description:
      "Get the Longbow data dashboard and signals for 20+ Global Commodity ETFs, including PALL, GUSH, GBTC, NIB, SGG, JO, COW, WOOD, SLV, SLB, UCO, GLD, XME, CORN, SOYB, BNO, CPER, USO, UNG, GDX, GDXJ, OIH, REMX.",
    selected: false,
  },
  {
    id: "income_dashboard",
    name: "Global Fixed Income ETF Dashboard",
    price: 10,
    description:
      "Get the Longbow data dashboard and signals for 10 US Fixed Income ETFs, including: SHY, TLT, IEF, LQD, EMB, TIP ZROZ, EDV, JNK, HYG.",
    selected: false,
  },
  {
    id: "crypto_dashboard",
    name: "Crypto Dashboard",
    price: 10,
    description:
      "Get the Longbow data dashboard and signals for your favorite crypto and crypto related securities, including: BTC, ETH, LTC, EOS, XMR, ZEC, DASH, GBTC, ETHE, MSTR, BLOK, COIN, OSTK, MARA, RIOT.",
    selected: false,
  },
  {
    id: "top25_dashboard",
    name: "Top 25",
    price: 50,
    description:
      "Get the Longbow data dashboard and signals for the top 25 buy/cover and sell/short stock picks.",
    selected: false,
  },
  {
    id: "signal_alerts",
    name: "Signal Alerts",
    price: 20,
    description:
      "Get alerts sent to your cell phone and/or email when there is a change in the:\n  ✓ Longbow Core Signal \n  ✓ Trading Range Signal\n  ✓ 30D Momentum Signal   \n  ✓ 90D Momentum Signal\n  ✓ Volatility Signal\nOn the securities you follow on your Longbow dashboard. Each Signal Alert can be customized by security by selecting “Set Alerts” on your Longbow dashboard.",
    selected: false,
  },
];

export default addons;
